import React, { useState } from "react";
import { footer } from "./viewAndEditTypes";
import "./viewAndEdit.css";
import {CircularProgress } from "@mui/material";
import { ConfirmationPopUp } from "../popup/confirmationPopUp";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
const ViewAndEditModalFooter = (props: footer) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const [showLoader, setShowLoader] = useState(false);
  const [openConfirmModal,setOpenConfirmModal] = useState<boolean>(false);
  return (
    <div className="model-content-button">
      {props.buttonText ? <button
        className={`${props.buttonText === "Approve" ? "active-model-button modal-submit-button" :
          props.check ? "active-model-button modal-submit-button" :
          "modal-submit-button"
      }`}
      onClick={async () => { 
        setShowLoader(true);
        {
          !showLoader &&
          await props.updateMethod();
          setShowLoader(false);
        }
       }}
      >
        {showLoader ? (
          <div >
            <CircularProgress size={15} color="inherit" />
            <span className="circular-progress-container">{translate(TranslationEnum.common_portal,props.buttonText)}</span>
          </div>
        ) : (
          <>{translate(TranslationEnum.common_portal,props.buttonText)}</>
        )}
      </button> : <button
        className={
          props.check
            ? "active-model-button modal-submit-button"
            : "modal-submit-button"
        }
        onClick={() =>  { if(props.check) setOpenConfirmModal(true) }}
      >
        {showLoader ? (
          <div >
            <CircularProgress size={15} color="inherit" />
            <span className="circular-progress-container">{translate(TranslationEnum.common_portal,"SUBMIT")}</span>
          </div>
        ) : (
          <>{translate(TranslationEnum.common_portal,"SUBMIT")}</>
        )}
      </button>
      }

      <ConfirmationPopUp
            setOpenConfirmModal={setOpenConfirmModal}
            message="Are you sure want to submit?"
            openConfirmModal = {openConfirmModal}
            successMethod = {async () => {
              setShowLoader(true);
              {!showLoader &&  
              await props.updateMethod();
              setShowLoader(false);}
            }}
            />
    </div>
  );
};

export default ViewAndEditModalFooter;
